import { createSelector } from '@ngrx/store';
import { addressProviderState } from '../root';

export const getAddressProviderSearchTerm = createSelector(addressProviderState, (addressProvider) => addressProvider?.search);
